import React from 'react';
import { formatLeaveItem, formatLeaveList } from 'selectors/leave';
import { getActiveIcon } from 'library/helpers';
import LeaveFormInput from './input';

const config = {
  // List Table
  list: {
    // Table Columns
    format: formatLeaveList,
    columns: [
      {
        title: 'Type',
        dataIndex: 'type__name',
        sorter: true,
        defaultSortOrder: 'ascend',
        width: '300px'
      },
      {
        title: 'Status',
        dataIndex: 'status__name',
        sorter: true,
        defaultSortOrder: 'ascend',
        width: '300px'
      },
      {
        title: 'Start Date',
        dataIndex: 'start_datetime',
        sorter: true,
        defaultSortOrder: 'ascend',
        width: '300px',
        render: (text, record) => (record.start_datetime && record.start_datetime.isValid() ? record.start_datetime.format('DD-MM-YYYY HH:mm') : 'N/A')
      },
      {
        title: 'End Date',
        dataIndex: 'end_datetime',
        sorter: true,
        defaultSortOrder: 'ascend',
        width: '300px',
        render: (text, record) => (record.end_datetime && record.end_datetime.isValid() ? record.end_datetime.format('DD-MM-YYYY HH:mm') : 'N/A')
      },
      {
        title: 'Requested',
        dataIndex: 'requested_date',
        sorter: true,
        defaultSortOrder: 'ascend',
        width: '300px',
        render: (text, record) => (record.requested_date && record.requested_date.isValid() ? record.requested_date.format('DD-MM-YYYY HH:mm') : 'N/A')
      },
      {
        title: 'Managed in 1SAP',
        dataIndex: 'is_integration_managed',
        width: '600px',
        align: 'center',
        sorter: true,
        filterMultiple: false,
        filters: [
          {
            text: 'Active',
            value: true
          },
          {
            text: 'Inactive',
            value: false
          }
        ],
        render: (text, record) => getActiveIcon(record.is_integration_managed)
      }
    ],
    isRecordDeletable: record => !record.is_integration_managed,
    // Deleting
    confirmMessage: () => (
      <div>
        <p>
          Are you sure you wish to delete the leave associated with this user ?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'type__name',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      type__name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['type__name'],
        searchValue: ''
      },
      status__name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['status__name'],
        searchValue: ''
      }
    },
    // General
    title: 'Leave',
    commands: {
      showDelete: false,
      showAdd: false
    }
  },
  // Detail Screen
  detail: {
    // General
    format: formatLeaveItem,
    emptyMessage: 'Please select a Record',
    title: 'Leave',
    component: props => (
      <LeaveFormInput
        {...props}
        inputFormItemLayout={{
          inputLayout: {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 8 }
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 16 }
            }
          },
          row: {
            gutter: 16
          },
          col: {
            span: 12
          }
        }}
        title="Leave"
      />
    )
  }
};

export default config;
